<template>
  <!-- ====== Footer ====== -->
  <div id="footer" class="clr">
    <div class="foot_son clr">
      <a href="tencent://message/?uin=&Site=qq&Menu=yes" target="_blank" class="fl qq"><img
          :src="'./images/qq.png'" /></a>
      <a href="tencent://message/?uin=&Site=qq&Menu=yes" target="_blank" class="fl qq"><img
          :src="'./images/qq1.png'" /></a>
      <a href="tel:4006028400" class="fl">
        <div class="pp fl">服务热线：4006-028-400</div>
      </a>
      <span class="fl"> 地址： </span>
      <a href="https://map.baidu.com/search/%E5%85%B4%E6%99%AE%E4%B8%AD%E5%BF%83-a%E5%BA%A7/@11579097.915,3574450.18,19z?querytype=s&da_src=shareurl&wd=%E5%85%B4%E6%99%AE%E4%B8%AD%E5%BF%83-A%E5%BA%A7&c=75&src=0&wd2=%E6%88%90%E9%83%BD%E5%B8%82%E9%87%91%E7%89%9B%E5%8C%BA&pn=0&sug=1&l=13&b=(11551489,3562770;11612929,3591922)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&sug_forward=8cc612798cbfccf1f7eafcb7&device_ratio=1" target="_blank" class="fl"
        style="text-decoration: none">四川省成都市金牛区兴普中心A座10楼2号 百度地图</a>
      <span class="fl">
        <a href="https://beian.miit.gov.cn" target="_blank"
          style="color: #ffffff; text-decoration: none">蜀ICP备09025130号-1</a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFooter',
};
</script>

<style lang="less" scoped>
/* 确保 footer 横向撑满 */
#footer {
  width: 100%;
}
</style>
